import { useMemo } from 'react';

import { buildPath } from '@e-socna/utils';
import type { BuildPathsParams } from '@e-socna/utils';

import { MISSION_SPACE_PARAM } from '../app/utils/mission-space.util';

import { useMissionSpace } from './useMissionSpace.hook';

// A mission path keeps the space of the current mission page.
export const useBuildPath = (
  path: string,
  params: Readonly<BuildPathsParams>,
) => {
  const missionSpace = useMissionSpace();

  return useMemo<string>(
    () => buildPath(path, { [MISSION_SPACE_PARAM]: missionSpace, ...params }),
    [missionSpace, path, params],
  );
};
